import React from 'react';
import { Box, Typography } from '@mui/material';

/** Keep supporting sources one click away while the required actions stay visible. */
export default function GuidanceReferences({ count, children }: { count: number; children: React.ReactNode }) {
  if (!count) return null;
  return <Box component="details" sx={{ mt: 1.5 }}>
    <Typography component="summary" variant="body2" sx={{ color: 'primary.main', cursor: 'pointer', py: 0.5,
      '&:focus-visible': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 } }}>
      References ({count})
    </Typography>
    <Box sx={{ mt: 0.5 }}>{children}</Box>
  </Box>;
}
